import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetLocationsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.form-default-values';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchEmspBoLocationListContextProvider,
  useEmspBoEmspLocationListContext,
} from '../../emsp-bo-location.context';
import { EmspBoLocationListFilterSearchFormController } from './emsp-bo-location-list-filter-search-form/emsp-bo-location-list-filter-search-form.controller';

interface EmspBoLocationListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoLocationListFilterSearchController = ({
  onCancel,
  onSuccess,
}: EmspBoLocationListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoEmspLocationListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetLocationsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-location-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetLocationsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      textToSearch: fieldValues.textToSearch,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetLocationsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterSearchEmspBoLocationListContextProvider data={data}>
      <EmspBoLocationListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchEmspBoLocationListContextProvider>
  );
};
